import fly from "../config/flyio";
export default {
    // 初始化
    getMPGSSessionId(data) {      
      // return fly.post("/VHISLoveYourSelf/SubmitPayment?AppNo="+data[0]+"&orderAmount="+data[1]);
      return fly.post("/VHISLoveYourSelf/SubmitPayment",data);
    },   
    getPremiumDisply(data){
      return fly.get("/VHISLoveYourSelf/PremiumDisply?AppNo="+data);
    },
    goToSuccess(data){
      return fly.post("/VHISLoveYourSelf/Success?AppNo="+data[0]+"&Lang="+data[1]);
    },
    gotoReapply(data){
      return fly.get("/VHISLoveYourSelf/Reapply?originalAppNo="+data);
    },
    getCheckUWCaseFn(data){
      return fly.get("/VHISLoveYourSelf/CheckUWCase?AppNo="+data);
    }
  };